export default __webpack_public_path__ + "static/media/Investor.acaa5359.svg";